<template>
  <div class="audit-articles-page">
    <!-- 面包屑导航 -->
    <nav class="breadcrumb-nav">
      <router-link to="/">首页</router-link>
      <span class="separator">/</span>
      <router-link to="/consulting/audit-risk-consulting">审计风控合规咨询</router-link>
      <span class="separator">/</span>
      <span class="current">专题文章</span>
    </nav>

    <div class="container">
      <!-- 页面标题 -->
      <div class="page-header">
        <h1 class="page-title">审计风控合规专题文章</h1>
        <p class="page-desc">精选智慧审计、风险导向审计、审计数字化、经责审计评价、内控及数据风控体系建设等深度内容，助力企业构建数字化审计与风险管控体系。</p>
      </div>

      <!-- 筛选栏 -->
      <div class="filter-bar">
        <div class="filter-tabs">
          <span class="filter-tab" :class="{ active: activeCategory === 'all' }" @click="activeCategory = 'all'">全部</span>
          <span class="filter-tab" :class="{ active: activeCategory === 'audit' }" @click="activeCategory = 'audit'">智慧审计</span>
          <span class="filter-tab" :class="{ active: activeCategory === 'risk' }" @click="activeCategory = 'risk'">风险内控</span>
          <span class="filter-tab" :class="{ active: activeCategory === 'compliance' }" @click="activeCategory = 'compliance'">合规管理</span>
          <span class="filter-tab" :class="{ active: activeCategory === 'evaluation' }" @click="activeCategory = 'evaluation'">经责审计</span>
          <span class="filter-tab" :class="{ active: activeCategory === 'data' }" @click="activeCategory = 'data'">数据风控</span>
        </div>
        <div class="search-box">
          <input type="text" class="search-input" placeholder="搜索文章..." v-model="searchKeyword" @keyup.enter="searchArticles">
          <button class="search-btn" @click="searchArticles">搜索</button>
        </div>
      </div>

      <!-- 文章列表 -->
      <div class="article-list">
        <div class="article-item" v-for="article in filteredArticles" :key="article.id" @click="openArticle(article.url)">
          <div class="article-meta">
            <span class="article-date">{{ article.date }}</span>
            <div class="article-tags">
              <span class="article-tag" v-for="tag in article.tags" :key="tag">{{ tag }}</span>
            </div>
          </div>
          <h2 class="article-title">{{ article.title }}</h2>
          <div class="article-summary">{{ article.summary }}</div>
          <div class="article-content-preview">{{ article.preview }}</div>
          <div class="article-footer">
            <span class="read-more">阅读全文 <i class="fas fa-arrow-right"></i></span>
            <span class="article-stats"><i class="fas fa-eye"></i> {{ article.views }}</span>
          </div>
        </div>
      </div>

      <!-- 分页 -->
      <div class="pagination">
        <span class="page-btn" @click="changePage(currentPage - 1)"><i class="fas fa-chevron-left"></i></span>
        <span class="page-btn" v-for="p in totalPages" :key="p" :class="{ active: currentPage === p }" @click="changePage(p)">{{ p }}</span>
        <span class="page-btn next" @click="changePage(currentPage + 1)">下一页 <i class="fas fa-chevron-right"></i></span>
      </div>

      <!-- 推荐文章侧栏 -->
      <div class="sidebar">
        <h3 class="sidebar-title">热门推荐</h3>
        <ul class="recommend-list">
          <li class="recommend-item" @click="openArticle('https://mp.weixin.qq.com/s/dDWpZ4xnygIG4d0sm3vc9Q?scene=1&click_id=9')">• 基于风险导向的、持续性的智慧审计</li>
          <li class="recommend-item" @click="openArticle('https://mp.weixin.qq.com/s/4iBed2PvoSkkuPnrPQGnsg')">• 经责审计智能评价体系及干部画像实践</li>
          <li class="recommend-item" @click="openArticle('https://mp.weixin.qq.com/s/kc2Y4-HMG8IOH0Zz1Tuz-A?scene=1')">• 【德勤】内控及数据风控体系建设</li>
          <li class="recommend-item" @click="openArticle('https://mp.weixin.qq.com/s/9-YHclKH6CXoMb6UdnatEA?scene=1&click_id=11')">• 内部审计赋能数字化转型</li>
          <li class="recommend-item" @click="openArticle('https://mp.weixin.qq.com/s/pwQF2G14f8YGhyQ_veqjkw?scene=1&click_id=13')">• AI时代银行版权风险管理探讨</li>
        </ul>
      </div>
    </div>

    <!-- 底部转化模块 -->
    <section id="contact">
      <div class="container">
        <div class="cta-section">
          <div class="cta-title">获取更多审计风控合规深度内容</div>
          <p style="font-size: 18px; margin-bottom: 30px;">订阅我们的邮件，每周获取最新审计风控实践文章与行业报告</p>
          <button class="btn-primary" @click="showSubscribeModal = true">立即订阅</button>
        </div>
      </div>
    </section>

    <!-- 订阅弹窗 -->
    <div class="modal-overlay" v-if="showSubscribeModal" @click.self="showSubscribeModal = false">
      <div class="modal-container">
        <span class="modal-close" @click="showSubscribeModal = false">&times;</span>
        <h3 style="margin-bottom: 20px;">订阅审计风控合规专题</h3>
        <form @submit.prevent="submitSubscribe">
          <div style="margin-bottom: 15px;">
            <input type="text" placeholder="姓名" style="width:100%; padding:12px; border-radius:8px; border:1px solid #ddd;">
          </div>
          <div style="margin-bottom: 15px;">
            <input type="email" placeholder="企业邮箱 *" style="width:100%; padding:12px; border-radius:8px; border:1px solid #ddd;">
          </div>
          <div style="margin-bottom: 15px;">
            <input type="text" placeholder="公司名称" style="width:100%; padding:12px; border-radius:8px; border:1px solid #ddd;">
          </div>
          <button class="btn-primary" style="width:100%;">确认订阅</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuditRiskArticles',
  data() {
    return {
      activeCategory: 'all',
      searchKeyword: '',
      searchActive: false,
      currentPage: 1,
      showSubscribeModal: false,
      articles: [
        {
          id: 1, category: 'audit', date: '2024-07-03',
          tags: ['智慧审计', '风险导向', '大数据审计'],
          title: '基于风险导向的、持续性的智慧审计',
          summary: '利用人工智能技术构建智慧审计系统，实现一个平台多数据源的生态产品，预计减少企业2/3的审计成本，改进审计质量，为企业管理层提供更高质量的审计成果。',
          preview: '智慧审计体系建设包括：成果最大化（审计指挥舱、领导干部画像、企业经营画像）、审计监督模型、流程作业工具、审计知识库、审计数据平台。覆盖审计监督评价、AI智能评价画像、审计成果最大化、数据湖、知识图谱等方面。客户群体为国资委强监管领域的央企、国企、事业单位，涉及审计部、风险管理部、合规法务部门。',
          views: '2.1k阅读',
          url: 'https://mp.weixin.qq.com/s/dDWpZ4xnygIG4d0sm3vc9Q?scene=1&click_id=9'
        },
        {
          id: 2, category: 'audit', date: '2024-09-24',
          tags: ['审计数字化', '风控合规', '一体化'],
          title: '审计风控合规数字化该怎么建',
          summary: '古杉数据专注于审计、风控、合规及法务一体化的核心业务能力介绍，阐述审计风控合规数字化的建设路径与差异化特点。',
          preview: '聚焦审计、风控、合规及法务一体化建设，探讨如何构建覆盖审计监督、风险预警、合规检查的数字化平台，实现从分散管理到协同联动的转变。',
          views: '1.8k阅读',
          url: 'https://mp.weixin.qq.com/s/TBnvmmThFjA8aybsCYJx0Q?scene=1&click_id=10'
        },
        {
          id: 3, category: 'audit', date: '2023-07-29',
          tags: ['内部审计', '数字化转型', '十大关键词'],
          title: '内部审计赋能数字化转型',
          summary: '中国信通院发布《内部审计赋能企业数字化转型十大关键词》，围绕内部IT审计三大核心任务、审计数字化转型五大关键要素，实现数字化时代内部审计角色升级。',
          preview: '十大关键词包括：数字化战略审计、数字化风险审计、数字合规审计、审计文化、审计组织、审计团队、审计流程、审计制度、审计协同、审计生态。通过科技强审和内外部能力共享，推动企业数字化战略落地、风险防控、合规经营和治理能力建设。',
          views: '2.5k阅读',
          url: 'https://mp.weixin.qq.com/s/9-YHclKH6CXoMb6UdnatEA?scene=1&click_id=11'
        },
        {
          id: 4, category: 'evaluation', date: '2024-09-17',
          tags: ['经责审计', '干部画像', '智能评价'],
          title: '经责审计智能评价体系及干部画像实践',
          summary: '构建领导干部经济责任审计智能评价体系，通过5个维度40多项指标实现定量+定性评价，同步生成干部画像和智能画像报告，应用于干部选班任免参考。',
          preview: '评价维度：战略决策、贯彻执行、合规管控、担当作为、履职尽责。项目实施中构建领导干部评价体系与审计问题库映射，实现一边审计一边评分一边画像，审计结束后自动生成智能画像报告，提供管理层更具洞察力的分析。',
          views: '1.9k阅读',
          url: 'https://mp.weixin.qq.com/s/4iBed2PvoSkkuPnrPQGnsg'
        },
        {
          id: 5, category: 'compliance', date: '2025-12-18',
          tags: ['版权风险', 'AI合规', '银行'],
          title: 'AI时代银行版权风险管理探讨',
          summary: '从法律法规、传统版权风险、AI新型风险、维权应对四个维度探讨银行版权管理，提出构建"制度+技术+合同+人工"四位一体的版权合规管理体系。',
          preview: '传统风险源于合规意识不足与管理流程缺失；AI时代风险呈现多元化、技术化、跨境化特征，覆盖数据采集、模型训练、内容生成、算法设计等全流程。收到维权邮件时应遵循"不回避、不忽视、不擅自回复"原则，启动内部联动和专业应对流程。',
          views: '1.6k阅读',
          url: 'https://mp.weixin.qq.com/s/pwQF2G14f8YGhyQ_veqjkw?scene=1&click_id=13'
        },
        {
          id: 6, category: 'risk', date: '2025-04-21',
          tags: ['德勤', '内控体系', '数据风控'],
          title: '【德勤】内控及数据风控体系建设',
          summary: '结合内部控制理论与实践，分享企业内控管理和风险防控体系建设经验，包括风险管理与内部控制区别、五阶段建设路径、信息化支撑及长效机制建设。',
          preview: '建设五阶段：梳理阶段（盘点流程、识别风险）、整改固化阶段（文件化标准化）、内控自评阶段（自我检查）、审计阶段（独立验证）、持续支撑（信息化建设、管理层持续整改）。通过引入风险管理系统等工具，提高内部控制的实时性和准确性。',
          views: '2.3k阅读',
          url: 'https://mp.weixin.qq.com/s/kc2Y4-HMG8IOH0Zz1Tuz-A?scene=1'
        }
      ]
    }
  },
  computed: {
    filteredArticles() {
      let list = this.articles
      if (this.activeCategory !== 'all') {
        list = list.filter(a => a.category === this.activeCategory)
      }
      if (this.searchActive && this.searchKeyword) {
        const kw = this.searchKeyword.toLowerCase()
        list = list.filter(a =>
          a.title.toLowerCase().includes(kw) ||
          a.summary.toLowerCase().includes(kw) ||
          a.preview.toLowerCase().includes(kw)
        )
      }
      return list
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.filteredArticles.length / 6)) || 1
    }
  },
  methods: {
    scrollTo(id) {
      const el = document.getElementById(id)
      if (el) el.scrollIntoView({ behavior: 'smooth' })
    },
    searchArticles() {
      this.searchActive = true
    },
    changePage(p) {
      if (p >= 1 && p <= this.totalPages) {
        this.currentPage = p
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    },
    openArticle(url) {
      window.open(url, '_blank')
    },
    submitSubscribe() {
      alert('订阅成功！')
      this.showSubscribeModal = false
    }
  },
  watch: {
    activeCategory() {
      this.currentPage = 1
    },
    searchKeyword(val) {
      if (!val) this.searchActive = false
    }
  }
}
</script>

<style scoped>
.audit-articles-page {
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  background-color: #ffffff;
  color: #2B2F3A;
  line-height: 1.6;
  --primary-blue: #1F3F8F;
  --deep-indigo: #0E1F52;
  --light-porcelain: #EAF0FB;
  --bg-light: #f5f7fa;
  --text-dark: #2B2F3A;
  --card-shadow: 0 12px 28px rgba(0,10,30,0.04), 0 4px 16px rgba(31,63,143,0.08);
  --border-light: #e9edf4;
  --nav-height: 60px;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}

/* 面包屑 */
.breadcrumb-nav {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px 24px;
  font-size: 14px;
  color: #5f6a7d;
}
.breadcrumb-nav a {
  color: #1F3F8F;
  text-decoration: none;
}
.breadcrumb-nav a:hover {
  text-decoration: underline;
}
.breadcrumb-nav .separator {
  margin: 0 8px;
  color: #ccc;
}
.breadcrumb-nav .current {
  color: #2B2F3A;
}

/* 固定导航 */
.nav-fixed {
  position: sticky;
  top: 60px;
  left: 0;
  width: 100%;
  background-color: white;
  box-shadow: 0 4px 20px rgba(0,0,0,0.02);
  z-index: 999;
  border-bottom: 1px solid rgba(31,63,143,0.1);
  height: var(--nav-height);
  backdrop-filter: blur(8px);
  background: rgba(255,255,255,0.9);
}
.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.nav-menu-inner {
  display: flex;
  gap: 8px;
  background-color: #f5f7fa;
  padding: 4px;
  border-radius: 40px;
}
.nav-item-inner {
  padding: 8px 20px;
  font-size: 15px;
  font-weight: 500;
  color: #2B2F3A;
  border-radius: 32px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  background-color: transparent;
  border: none;
  white-space: nowrap;
}
.nav-item-inner:hover {
  background-color: #EAF0FB;
  color: #1F3F8F;
}
.nav-item-inner.active {
  background-color: #1F3F8F;
  color: white;
  font-weight: 600;
  box-shadow: 0 4px 10px rgba(31,63,143,0.2);
}

/* 页面标题 */
.page-header {
  margin-bottom: 40px;
  margin-top: 20px;
}
.page-title {
  font-size: 38px;
  font-weight: 700;
  color: var(--deep-indigo);
  margin-bottom: 16px;
}
.page-desc {
  font-size: 18px;
  color: #5f6a7d;
  max-width: 800px;
}

/* 筛选栏 */
.filter-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
  flex-wrap: wrap;
  gap: 20px;
}
.filter-tabs {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.filter-tab {
  padding: 8px 24px;
  border-radius: 40px;
  background: white;
  border: 1px solid var(--border-light);
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
}
.filter-tab.active, .filter-tab:hover {
  background: var(--primary-blue);
  color: white;
  border-color: var(--primary-blue);
}
.search-box {
  display: flex;
  gap: 8px;
}
.search-input {
  padding: 10px 16px;
  border-radius: 40px;
  border: 1px solid var(--border-light);
  width: 250px;
  font-size: 14px;
}
.search-btn {
  padding: 10px 24px;
  border-radius: 40px;
  background: var(--primary-blue);
  color: white;
  border: none;
  cursor: pointer;
  transition: 0.3s;
}
.search-btn:hover {
  background: #0e3170;
}

/* 文章列表 */
.article-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 30px;
  margin-bottom: 50px;
}
.article-item {
  background: white;
  border-radius: 16px;
  padding: 32px;
  box-shadow: var(--card-shadow);
  transition: all 0.3s;
  cursor: pointer;
  border: 1px solid rgba(31,63,143,0.05);
}
.article-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 24px 40px rgba(31,63,143,0.12);
}
.article-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
}
.article-date {
  color: #5f6a7d;
  font-size: 14px;
  background: var(--bg-light);
  padding: 4px 12px;
  border-radius: 40px;
}
.article-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.article-tag {
  background: var(--light-porcelain);
  padding: 4px 12px;
  border-radius: 40px;
  font-size: 12px;
  color: var(--primary-blue);
}
.article-title {
  font-size: 24px;
  font-weight: 600;
  color: var(--deep-indigo);
  margin-bottom: 12px;
  line-height: 1.4;
}
.article-summary {
  color: #5f6a7d;
  margin-bottom: 20px;
  line-height: 1.7;
  border-left: 3px solid var(--light-porcelain);
  padding-left: 20px;
}
.article-content-preview {
  color: var(--text-dark);
  margin-bottom: 20px;
  font-size: 15px;
  line-height: 1.7;
  background: #fafbfc;
  padding: 20px;
  border-radius: 12px;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid var(--border-light);
}
.article-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.read-more {
  color: var(--primary-blue);
  text-decoration: none;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: gap 0.3s;
}
.article-item:hover .read-more {
  gap: 12px;
}
.article-stats {
  font-size: 14px;
  color: #8a95a8;
}

/* 分页 */
.pagination {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin: 60px 0;
}
.page-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border: 1px solid var(--border-light);
  cursor: pointer;
  transition: all 0.3s;
}
.page-btn:hover, .page-btn.active {
  background: var(--primary-blue);
  color: white;
  border-color: var(--primary-blue);
}
.page-btn.next {
  width: auto;
  padding: 0 16px;
  border-radius: 40px;
}

/* 推荐文章侧栏 */
.sidebar {
  background: var(--bg-light);
  border-radius: 16px;
  padding: 24px;
  margin-top: 40px;
}
.sidebar-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  color: var(--deep-indigo);
}
.recommend-list {
  list-style: none;
  padding: 0;
}
.recommend-item {
  padding: 12px 0;
  border-bottom: 1px solid var(--border-light);
  cursor: pointer;
  transition: color 0.3s;
}
.recommend-item:hover {
  color: var(--primary-blue);
}

/* 底部转化 */
.cta-section {
  background: var(--deep-indigo);
  border-radius: 32px;
  padding: 60px;
  color: white;
  text-align: center;
  margin: 60px 0;
}
.cta-title {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 16px;
}
.btn-primary {
  display: inline-block;
  background: var(--primary-blue);
  color: white;
  border: none;
  padding: 14px 36px;
  border-radius: 60px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
  text-decoration: none;
  font-size: 16px;
}
.btn-primary:hover {
  background: #0e3170;
  transform: translateY(-2px);
}

/* 弹窗 */
.modal-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(11,26,51,0.6);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-container {
  background: white;
  border-radius: 32px;
  padding: 40px;
  max-width: 500px;
  width: 90%;
}
.modal-close {
  float: right;
  font-size: 24px;
  cursor: pointer;
}

@media (max-width: 768px) {
  .filter-bar {
    flex-direction: column;
    align-items: stretch;
  }
  .search-box {
    width: 100%;
  }
  .search-input {
    width: 100%;
  }
  .page-title {
    font-size: 28px;
  }
}
</style>
